import { Instagram, Mail, ArrowUpRight } from "lucide-react";

export const Footer = () => {
    return (
        <footer
            id="contact"
            data-testid="footer-section"
            className="relative px-6 sm:px-10 pt-24 pb-12 border-t border-white/10 bg-black"
        >
            <div className="max-w-[1400px] mx-auto">
                {/* Massive MAD type */}
                <div className="text-[11px] uppercase tracking-[0.3em] text-[#D91C1C] mb-6">
                    06 / Kontakt
                </div>

                {/* Bull logo above MAD type */}
                <img
                    data-testid="footer-bull-logo"
                    src="https://customer-assets.emergentagent.com/job_mad-drinks/artifacts/35o1dtom_ChatGPT%20Image%2020.%206.%202026%2C%2009_50_18.png"
                    alt="MAD bull logo"
                    className="w-32 sm:w-44 h-auto mb-4"
                />

                <h2
                    data-testid="footer-heading"
                    className="font-display uppercase text-white leading-[0.82] tracking-tighter text-[28vw] sm:text-[22vw] lg:text-[16rem]"
                >
                    M<span className="text-[#D91C1C]">A</span>D
                </h2>

                <div className="mt-12 grid grid-cols-12 gap-8 border-t border-white/10 pt-12">
                    <div className="col-span-12 md:col-span-5">
                        <p className="text-lg text-white/70 max-w-md">
                            Chceš fľašu, dúšok, alebo sa len opýtať, čo to
                            dopekla je? Napíš.
                        </p>
                    </div>

                    <div className="col-span-6 md:col-span-3">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-4">
                            Email
                        </div>
                        <a
                            data-testid="contact-email-link"
                            href="mailto:maddrinksss@gmail.com"
                            className="group inline-flex items-center gap-2 text-xl text-white hover:text-[#D91C1C] transition-colors"
                        >
                            maddrinksss@gmail.com
                            <ArrowUpRight
                                size={18}
                                className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                            />
                        </a>
                    </div>

                    <div className="col-span-6 md:col-span-4">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-4">
                            Sociálne siete
                        </div>
                        <div className="flex flex-col gap-3">
                            <a
                                data-testid="contact-instagram-link"
                                href="https://instagram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group inline-flex items-center gap-3 text-xl text-white hover:text-[#D91C1C] transition-colors"
                            >
                                <Instagram size={18} />
                                @maddrink
                                <ArrowUpRight
                                    size={16}
                                    className="opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all"
                                />
                            </a>
                            <a
                                data-testid="contact-email-icon-link"
                                href="mailto:hello@maddrink.co"
                                className="group inline-flex items-center gap-3 text-xl text-white hover:text-[#D91C1C] transition-colors"
                            >
                                <Mail size={18} />
                                Napíš správu
                                <ArrowUpRight
                                    size={16}
                                    className="opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all"
                                />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-16 flex flex-wrap items-center justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-white/30">
                    <div data-testid="footer-copyright">
                        © {new Date().getFullYear()} MAD — Vyrobené doma,
                        podávané silne.
                    </div>
                    <div>Edícia 1.0 · Iba malá séria</div>
                </div>
            </div>
        </footer>
    );
};
